// src/pages/Planner/PlannerFormPage.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader } from "lucide-react";
import api from "@/lib/axios"; // adjust if your path differs

export default function PlannerFormPage() {
  const [planner_name, setPlannerName] = useState("");
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!planner_name.trim()) return;

    setSaving(true);
    try {
      await api.post("/planners", { planner_name: planner_name.trim() }); // ✅ no /solo-mdsh-api here
      navigate("/planners");
    } catch (e) {
      console.error("Create planner failed:", e);
      alert(e?.response?.data?.error || "Failed to create planner");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen p-6 bg-gradient-to-br from-black via-gray-900 to-gray-950 text-white">
      <div className="max-w-xl mx-auto bg-[#101010] border border-white/10 rounded-xl p-6">
        <h1 className="text-2xl font-extrabold mb-4">👤 New Planner</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <label className="block">
            <span className="text-sm text-gray-300">Planner Name *</span>
            <input
              className="mt-1 w-full rounded bg-black/40 border border-white/10 px-3 py-2 outline-none"
              value={planner_name}
              onChange={(e) => setPlannerName(e.target.value)}
              placeholder="e.g., John Smith"
              required
            />
          </label>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              disabled={saving}
              className="px-4 py-2 rounded bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 inline-flex items-center gap-2"
            >
              {saving ? <Loader className="w-4 h-4 animate-spin" /> : null}
              Save
            </button>

            <Link to="/planners" className="px-4 py-2 rounded bg-gray-700 hover:bg-gray-600">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
